module.exports = __webpack_public_path__ + "img/preparing-files.e4169d5c.svg";